import { Component, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { IdiomaService } from "../../services/idioma.service";
import { Subscription } from "rxjs";
import { DropDownComponent } from "./drop-down/drop-down.component";


@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    DropDownComponent
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css'
})
export class HeaderComponent implements OnInit, OnDestroy {
  idiomas = [
    { id: 'idioma-1', label: 'Português', icon: '🇧🇷' },
    { id: 'idioma-2', label: 'Inglês', icon: '🇺🇸' },
    { id: 'idioma-3', label: 'Espanhol', icon: '🇪🇸' }
  ];

  selectedIdioma = this.idiomas[0];
  dropdownOpen: boolean = false;
  activeIdioma = this.selectedIdioma;

  @Output() idiomaAlterado: EventEmitter<string> = new EventEmitter<string>();

  private idiomaSubscription: Subscription = new Subscription();

  constructor(private idiomaService: IdiomaService) {};

  ngOnInit(): void {
    this.idiomaSubscription = this.idiomaService.idioma$.subscribe(idioma => {
      console.log('Idioma alterado para:', idioma);
    });
  }

  ngOnDestroy(): void {
    if (this.idiomaSubscription) {
      this.idiomaSubscription.unsubscribe();
    }
  }

  onIdiomaAlterado(idioma: string): void {
    this.idiomaAlterado.emit(idioma);
    console.log('Idioma alterado para:', idioma);
  }

}



